import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import ForSaleProperties from './pages/ForSaleProperties';
import ForRentProperties from './pages/ForRentProperties';
import SoldProperties from './pages/SoldProperties';
import PropertyDetail from './pages/PropertyDetail';
import About from './pages/About';
import OurTeam from './pages/OurTeam';
import Contact from './pages/Contact';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import Reposeidas from './pages/Reposeidas';
import Resources from './pages/Resources';
import MLS from './pages/MLS';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <Router>
          <div className="App">
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/properties/for-sale/ponce" element={<ForSaleProperties />} />
              <Route path="/properties/for-sale/santa-isabel" element={<ForSaleProperties />} />
              <Route path="/properties/for-sale/guayama" element={<ForSaleProperties />} />
              <Route path="/properties/for-sale/lajas" element={<ForSaleProperties />} />
              <Route path="/properties/for-sale" element={<ForSaleProperties />} />
              <Route path="/casas-en-venta" element={<ForSaleProperties />} />
              <Route path="/casas-reposeidas" element={<ForSaleProperties />} />
              <Route path="/properties/for-rent" element={<ForRentProperties />} />
              <Route path="/properties/sold" element={<SoldProperties />} />
              <Route path="/property/:id" element={<PropertyDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/our-team" element={<OurTeam />} />
              <Route path="/reposeidas" element={<Reposeidas />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/mls" element={<MLS />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
            <Footer />
          </div>
        </Router>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
